import React from 'react'
import '../App.css'

export default function SimpleText() {
    return (
        <div className='main'>
            <div className="simple-text">
                <p>
                    Terzo gives you the power of <span className="important-text">Artificial Intelligence </span>
                    through a unique AI-as-a-Service model. This allows
                    you to <span className="important-text">focus on strategic work </span>instead of the operational
                    burden and cost of reviewing contracts manually.
                    Quickly <span className="important-text">identify data </span> that matters to your organization
                    with dynamic analytics dashboards. Gain <span className="important-text">full confidence </span>
                    in data quality with humans in the loop performing QA
                    on every contract.
                </p>
            </div>
        </div>
    )
}